import React, { Component } from "react";

import CircleIcon from "../../prefabs/circle-icon/view";
// import Icon       from "../../prefabs/icon/view";



class LocationItem extends Component {

  // ===============================================================================================
  constructor(props) {
    super(props);

    this.onClick   = this.onClick.bind(this);
    this.isTooLow  = this.isTooLow.bind(this);
    this.isTooHigh = this.isTooHigh.bind(this);
    this.locationInactive = false;
  }



  // ===============================================================================================
  onClick(e) {
    e.preventDefault();
    // console.log(`LOCATION:\n Clicked location: ${this.props.details.id} : ${this.props.details.name}`);

    // if (!(this.isTooLow() || this.isTooHigh())) {
      this.props.handleClick(this.props.details.id);
    // }
  }



  // ===============================================================================================
  isTooLow() {
    return (this.props.numAttending < this.props.minCapacity) ? true : false;
  }



  // ===============================================================================================
  isTooHigh() {
    return (this.props.numAttending > this.props.maxCapacity) ? true : false;
  }



  // ===============================================================================================
  render() {
    // ---------------------------------------------------------------------------------------------
    let inactive = false;
    // let capacity = null;
    // let extra    = null;
    let eventTypeInfo = '';
    let locationInactive = false;

    let capacityInfo = {
      "hosted": "Capacity Min " + this.props.minCapacity + " - Max " + this.props.maxCapacity + " children",
      "no-host": "Capacity Min " + this.props.minCapacity + " - Max " + this.props.maxCapacity + " people"
    }



    // ---------------------------------------------------------------------------------------------
    if (this.isTooLow()) {
      // inactive = true;
      // capacity = (
      //   <div className="location-item__content__capacity">
      //     (Min capacity of this party space is {this.props.minCapacity})
      //   </div>
      // );
    }



    // ---------------------------------------------------------------------------------------------
    if (this.isTooHigh()) {
      // inactive = true;
      // capacity = (
      //   <div className="location-item__content__capacity">
      //     (Max capacity of this party space is {this.props.maxCapacity})
      //   </div>
      // );
      // extra = (
      //   <div className="location-item__content__service">
      //     For larger bookings please contact customer service - <a tabIndex="-1" href="tel:1300268710">1300 268 710</a>
      //   </div>
      // );
    }


    if (this.props.item.event_type_hosted === 1 && this.props.item.event_type_no_host === 1) {
      eventTypeInfo = "Restaurant supports hosted birthday parties and event space bookings";
    } else if (this.props.item.event_type_hosted === 1) {
      if (this.props.eventType === 'hosted') {
        eventTypeInfo = "Restaurant supports hosted birthday parties";
      } else {
        eventTypeInfo = "Restaurant does not support event space bookings";
        locationInactive = true;
      }

    } else if (this.props.item.event_type_no_host === 1) {
      if (this.props.eventType === 'no-host') {
        eventTypeInfo = "Restaurant supports event space bookings";
      } else {
        eventTypeInfo = "Restaurant does not support hosted birthday parties";
        locationInactive = true;
      }
    } else if (this.props.item.event_type_hosted === 0 && this.props.item.event_type_no_host === 0) {
      eventTypeInfo = "Restaurant does not support hosted birthday parties or event space bookings";
      locationInactive = true;
    }


    // ---------------------------------------------------------------------------------------------
    return (
      <button className={"location-item" +
        ((this.props.selected) ? " location-item--selected" : "") +
        ((inactive) ? " location-item--inactive" : "")}
        tabIndex="-1"
        onClick={ locationInactive ? undefined : this.onClick }>

        <div className="location-item__content">

          <div className="location-item__content__name">
            {/* <div className="location-item__content__name__icon">
              <Icon type={"loc-marker" + ((this.props.selected) ? "-sel" : "")}/>
            </div> */}
            {this.props.details.name}
          </div>

          <div className="location-item__content__address">
            {this.props.details.address}<br/>
            {/* {(this.props.details.distance_to_visitor) ? this.props.details.distance_to_visitor + "km away" : ""} */}
          </div>

          <div className="location-item__content__capacity">
            {capacityInfo[this.props.eventType]}
          </div>

          <div className="location-item__content__event_type_info">
            {eventTypeInfo}
          </div>
          

          {/* {capacity} */}
          {/* {extra} */}

        </div>

        <div className="location-item__toggle">
          {locationInactive ? (
            <CircleIcon
              disabled={true}
              checked={false}
              type=""
            />
          ) : (
            <CircleIcon
              checked={this.props.selected}
              type={(this.props.selected) ? "checkmark-b" : ""}
            />
          )}
        </div>

      </button>
        );
      }
    
    }



export default LocationItem
